<template>
  <div class="wrapper">
    <base-circular-loader v-if="loading" />

    <div v-else class="wrapper wrapper-column">
      <base-button color="transparent"
                   :disabled="allSocialMediaBlocked"
                   @click="blockAll">
        {{ $t("socialMedia.blockAll") }}
      </base-button>

      <div class="divider" />

      <base-button color="transparent"
                   :disabled="unsupportedSocialMediaBlocked"
                   @click="blockUnsupported">
        {{ $t("socialMedia.blockUnsupported") }}
      </base-button>

      <div class="divider" />

      <social-media-hint @click="openHint" />

      <div class="divider" />

      <div class="list">
        <div class="list-header list-header-left list-header-primary list-header-upper">
          {{ $t("socialMedia.title2") }}
        </div>

        <social-media-facebook-instagram :child-id="childId" />

        <div v-for="(app, index) in protectedSocialMedia"
            class="list-item list-item-no-border list-item-sm"
            :key="index">
          <social-media-app :app="app"
                            @changeAction="changeAction" />
        </div>
      </div>

      <div class="divider" />

      <div class="list">
        <div class="list-header list-header-left list-header-primary list-header-upper">
          {{ $t("socialMedia.otherSocialMedia") }}
        </div>

        <div v-for="(app, index) in unsupportedSocialMedia"
            class="list-item list-item-no-border list-item-sm"
            :key="index">
          <social-media-app :app="app"
                            @changeAction="changeAction" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SocialMediaApp from '@/components/Child/ChildSocialMedia/SocialMediaApp'
  import SocialMediaHint from '@/components/Child/ChildSocialMedia/SocialMediaHint'
  import SocialMediaFacebookInstagram from '@/components/Child/ChildSocialMedia/SocialMediaFacebookInstagram'

  import analytics from '@/services/analytics.js'

  export default {
    components: {
      SocialMediaApp,
      SocialMediaHint,
      SocialMediaFacebookInstagram
    },

    props: {
      childId: {
        type: String,
        required: true
      }
    },

    data: () => ({
      loading: true
    }),

    created() {
      analytics.sendEvent('SocialMedia_Sc')

      this.initSocialMedia()
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
        getAllSocialMedia: 'getAllSocialMedia',
        getProtectedSocialMedia: 'getProtectedSocialMedia',
        getUnsupportedSocialMedia: 'getUnsupportedSocialMedia'
      }),

      child() {
        return this.getChildById(this.childId)
      },

      protectedSocialMedia() {
        return this.getProtectedSocialMedia(this.childId)
      },

      unsupportedSocialMedia() {
        return this.getUnsupportedSocialMedia(this.childId)
      },

      allSocialMediaApps() {
        return this.getAllSocialMedia(this.childId)
      },

      allSocialMediaBlocked() {
        return this.allSocialMediaApps.every(app => app.app_action === 'block')
      },

      unsupportedSocialMediaBlocked() {
        return this.unsupportedSocialMedia.every(app => app.app_action === 'block')
      }
    },

    methods: {
      ...mapActions('children', {
        loadSocialMedia: 'loadSocialMedia',
        blockAllSocialMedia: 'blockAllSocialMedia',
        allowAllSocialMedia: 'allowAllSocialMedia',
        updateProtectedSocialMedia: 'updateProtectedSocialMedia',
        updateUnsupportedSocialMedia: 'updateUnsupportedSocialMedia',
        blockUnsupportedSocialMedia: 'blockUnsupportedSocialMedia',
        allowUnsupportedSocialMedia: 'allowUnsupportedSocialMedia'
      }),

      async initSocialMedia() {
        this. loading = true

        await this.loadSocialMedia(this.childId)

        this.loading = false
      },

      blockAll() {
        analytics.sendEvent('Pk_BlockAll_SocMedia')

        this.blockAllSocialMedia(this.childId)
      },

      blockUnsupported() {
        analytics.sendEvent('Pk_BlockUnsprtd_SocMedia')

        this.blockUnsupportedSocialMedia(this.childId)
      },

      changeAction(app) {
        const { app_name, app_action } = app

        if (app.supports_protection) {
          analytics.sendEvent('St_AlwBlckPrtct_SocMedia')

          this.updateProtectedSocialMedia({
            user_id: this.childId,
            app_name,
            app_action
          })

          return
        }

        analytics.sendEvent('St_AlwBlck_SocMedia')

        this.updateUnsupportedSocialMedia({
          user_id: this.childId,
          app_name,
          app_action
        })
      },

      openHint() {
        analytics.sendEvent('Pk_HelpMe_SocMedia')
      }
    }
  }
</script>